import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { CommonService } from '../../../_services/common.service';
import { NavService } from '../../../_services/NavService.service';
import { UserService } from '../../../auth/_services';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { NetworkService } from '../../services/network/network.service';
import { OrdersService } from '../../services/orders/orders.service';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';

@Component({
  selector: 'app-record-income',
  templateUrl: './record-income.component.html',
  styleUrls: ['./record-income.component.scss']
})
export class RecordIncomeComponent implements OnInit, OnChanges {

  static that: RecordIncomeComponent;
  TenantId: any;
  CompanyId: any;
  userId: any;
  dataToSave: any = {};
  @Output() onCloseBtnClick = new EventEmitter<any>();
  @Input() CustomerId: any;
  isEditMode: boolean = false;
  lastSN: number = 1;
  @Input() ScreenName: any;

  ChargedId: any = {
    lable: 'Charges',
    formControlName: 'ChargedId',
    dataField: 'ChargedId',
    isRequired: true,
    placeholder: 'Select Charges',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  Unit: any = {
    lable: 'Unit',
    formControlName: 'Unit',
    dataField: 'Unit',
    isRequired: true,
    placeholder: 'Select Unit',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  ChargedGST = {
    lable: 'Charged GST',
    formControlName: 'ChargedGST',
    dataField: 'ChargedGST',
    isRequired: false,
    placeholder: 'Enter Charged GST',
  };
  Quantity = {
    lable: 'Quantity',
    formControlName: 'Quantity',
    dataField: 'Quantity',
    isRequired: true,
    placeholder: 'Enter Quantity',
    type: 'number'
  };
  Rate = {
    lable: 'Rate',
    formControlName: 'Rate',
    dataField: 'Rate',
    isRequired: true,
    placeholder: 'Enter Rate',
    type: 'number'
  };
  Amount = {
    lable: 'Amount',
    formControlName: 'Amount',
    dataField: 'Amount',
    isRequired: false,
    placeholder: 'Enter Amount',
    type: 'number'
  };
  Discount = {
    lable: 'Discount',
    formControlName: 'Discount',
    dataField: 'Discount',
    isRequired: false,
    placeholder: 'Enter Discount',
    type: 'number'
  };
  Advance = {
    lable: 'Advance',
    formControlName: 'Advance',
    dataField: 'Advance',
    isRequired: false,
    placeholder: 'Enter Advance',
    type: 'number'
  };
  Remark = {
    lable: 'Remark',
    formControlName: 'Remark',
    dataField: 'Remark',
    isRequired: false,
    placeholder: 'Enter Remark',
    // type: 'textarea'
  };
  VehicleTypeId: any = {
    lable: 'Vehicle Type',
    formControlName: 'VehicleTypeId',
    dataField: 'VehicleTypeId',
    isRequired: false,
    placeholder: 'Select Vehicle Type',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  tableDetails: ITableModel;
  @Input() IndentId: any;
  @Input() ConsignmentNo: any;
  @Input() IsConsignmentWise: boolean = false;
  @Input() OrderNo: any;
  @Input() ConsignmentNoteDetailId: any;
  @Input() isOrderLevel: boolean=false;
  @Input() BookingId: any;
  @Output() refreshCostSheet = new EventEmitter<any>();

  ConsignmentDetailIds: any = {
    lable: 'Consignment No',
    formControlName: 'ConsignmentDetailId',
    dataField: 'ConsignmentDetailId',
    isRequired: false,
    placeholder: 'Select consignment no',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true,
    isReadOnly:true
  };

  constructor(private router: Router, private route: ActivatedRoute,
    private _appService: appService, private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
    private commonService: CommonService,
    private networkService: NetworkService,
    private userService: UserService,
    private _navService: NavService,
    private mobileDetectionService: MobileDetectionService,
    private modalService: NgbModal,
    private dp: DatePipe,
    private orderService: OrdersService,
  ) {
    RecordIncomeComponent.that = this;
  }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
    this.InitializeData();
    if(this.isOrderLevel === true){
      this.ConsignmentDetailIds.isReadOnly = false;
    }else{
      this.ConsignmentDetailIds.isReadOnly = true;
    }

    if(this.IndentId){
      this.GetConsignmentList('%%', false, false);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
    this.InitializeData();

    if (changes['IndentId'] || changes['ConsignmentNoteDetailId']) {
      this.GetChargeList();
      this.dataToSave.ConsignmentDetailId = this.ConsignmentNoteDetailId;
      this.dataToSave.ConsignmentNo = this.ConsignmentNo;
       this.GetConsignmentList(this.ConsignmentNo);
    }
  }

  closeModal() {
    this.onCloseBtnClick.emit();
  }

  GetChargesList(value, isScrollDown = false) {
    this.ChargedId.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.ChargedId.dropdownList.length / 20) + 1;
    }
    this.orderService.ChargesSelect2Recordincome(value, pageNo, this.TenantId, this.CompanyId, this.CustomerId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.ChargedId.dropdownList.length) {
        dropdownList = dropdownList.concat(this.ChargedId.dropdownList);
        this.ChargedId = { ...this.ChargedId, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.ChargedId = { ...this.ChargedId, dropdownList: [...dropdownList] });
      this.ChargedId.isSearch = false;
    }).catch(error => {
      this.ChargedId.isSearch = false;
    })
  }

  GetVehicleTypeList(value, isScrollDown = false) {
    this.VehicleTypeId.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleTypeId.dropdownList.length / 20) + 1;
    }
    this.orderService.GetSelectOrderVehicleList(value, pageNo, this.IndentId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleTypeId.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleTypeId.dropdownList);
        this.VehicleTypeId = { ...this.VehicleTypeId, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleTypeId = { ...this.VehicleTypeId, dropdownList: [...dropdownList] });
      this.VehicleTypeId.isSearch = false;
    }).catch(error => {
      this.VehicleTypeId.isSearch = false;
    })
  }

  getChangedValue(value, data) {
    if (value) {
      if (data.dataField == 'ChargedId') {
        this.dataToSave[data.dataField] = value.value;
        this.dataToSave.ChargedGST = value.ChargeGST;
        this.dataToSave.ChargeCode = value.name;
        this.dataToSave.IsGSTApplicable = value.IsGSTApplicable;
        this.dataToSave.SGST = value.SGST;
        this.dataToSave.CGST = value.CGST;
        this.dataToSave.IGST = value.IGST;
      } else if (data.dataField == 'VehicleTypeId') {
        this.dataToSave[data.dataField] = value.value;
        this.dataToSave.VehicleTypeName = value.name;
      } else if (data.dataField == 'ConsignmentDetailId') {
        this.dataToSave[data.dataField] = value.value;
        this.dataToSave.ConsignmentNo = value.name;
        // Added by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
        if (value.VehicleTypeId && value.VehicleTypeName) {
          this.dataToSave.VehicleTypeId = value.VehicleTypeId;
          this.dataToSave.VehicleTypeName = value.VehicleTypeName;
          this.GetVehicleTypeList(this.dataToSave.VehicleTypeName);
          this.VehicleTypeId.isReadOnly = true;
        } else {
          this.VehicleTypeId.isReadOnly = false;
        }
        // End by priya
      } else if(data.dataField == 'Unit') {  //added by fahim 12-01-2026 :)
        this.dataToSave[data.dataField] = value.value;
        this.CalculateChargesByUnit(value.value);  //End added by fahim 12-01-2026 :)
      } else {
        this.dataToSave[data.dataField] = value;
        if (data.dataField == 'Quantity' || data.dataField == 'Rate' || data.dataField == 'Discount') {
          this.OnChangeAddInvoice();
        }
      }
    }else{
      if(data.dataField == 'Advance'){
        this.dataToSave[data.dataField] = 0;
      }
      if(data.dataField == 'Discount'){
        this.dataToSave[data.dataField] = 0;
      }
    }

    console.log('value:',value , 'data',data);
  }

  OnChangeUnit(Unit) {
    if (Unit == "Weight") {
      this.dataToSave.Quantity = this.dataToSave.PaidWeight;
    } else if (Unit == "Package") {
      this.dataToSave.Quantity = this.dataToSave.Package;
    } else if (Unit == "Vehicle") {
      this.dataToSave.Quantity = 1;
    } else if (Unit == "Shortage") {
      this.dataToSave.Quantity = this.dataToSave.ShortageQuantity;
    } else if (Unit == "FixedKMMonth") {
      this.dataToSave.Quantity = this.dataToSave.FixedKMMonthQTY;
    } else {
      this.dataToSave.Quantity = 1;
    }
  }

  isFormSubmit: boolean = false;
  addIncomeAmount() {
    this.isFormSubmit = true;
    if (!this.dataToSave.ChargedId) {
      this.toastr.error('Select Charge!', 'Error');
      return false;
    }
    if (!this.dataToSave.Unit) {
      this.toastr.error('Select Unit!', 'Error');
      return false;
    }

    if (this.dataToSave.Amount != 0) {
      var obj: any = {};
      obj.ChargeCode = this.dataToSave.ChargeCode;
      obj.Unit = this.dataToSave.Unit;
      obj.ChargedGST = this.dataToSave.ChargedGST;
      obj.Quantity = this.dataToSave.Quantity;
      obj.Rate = this.dataToSave.Rate ? parseFloat(this.dataToSave.Rate).toFixed(2) : 0.00;
      obj.Amount = this.dataToSave.Amount ? parseFloat(this.dataToSave.Amount).toFixed(2) : 0.00;
      obj.Advance = this.dataToSave.Advance ? parseFloat(this.dataToSave.Advance).toFixed(2) : 0.00;
      obj.Discount = this.dataToSave.Discount ? parseFloat(this.dataToSave.Discount).toFixed(2) : 0.00;
      // obj.SN = this.tableDetails.data ? (this.tableDetails.data.length + 1) : 1;
      obj.SN = this.lastSN;
      this.lastSN++;
      obj.Remark = this.dataToSave.Remark;
      obj.ChargedId = this.dataToSave.ChargedId;
      obj.CGST = this.dataToSave.CGST;
      obj.SGST = this.dataToSave.SGST;
      obj.IGST = this.dataToSave.IGST;
      obj.VehicleTypeId = this.dataToSave.VehicleTypeId;
      obj.VehicleTypeName = this.dataToSave.VehicleTypeName;
      obj.Id = this.dataToSave.Id ? this.dataToSave.Id : null;
      obj.ConsignmentDetailId = this.dataToSave.ConsignmentDetailId ? this.dataToSave.ConsignmentDetailId : null;
      obj.ConsignmentNo = this.dataToSave.ConsignmentNo ? this.dataToSave.ConsignmentNo : null;
      obj.UserId = this.userId;
      this.tableDetails.data.push(obj);

      this.dataToSave = {};
      this.isFormSubmit = false;
      this.CalcFooterValue();
      this.isEditMode = false;
    } else {
      this.toastr.error("Amount is zero !", "error");
    }
  }

  InitializeData() {
    this.tableDetails = {
      data: [],
      emptyDataMSg: "No Records Found",
      columnDetails: [
        { columnName: "Charge", dataFieldName: "ChargeCode",width:'14%' },
        { columnName: "Unit", dataFieldName: "Unit",width:'5%' },
        { columnName: "GST", dataFieldName: "ChargedGST",width:'5%' },
        { columnName: "Qty", dataFieldName: "Quantity",alignType:'right',width:'5%' },
        { columnName: "Rate", dataFieldName: "Rate", alignType:'right',width:'8%'},
        { columnName: 'Discount', dataFieldName: 'Discount',alignType:'right',width:'8%' },
        { columnName: "Amount", dataFieldName: "Amount", alignType:'right',width:'10%'},
        { columnName: "Advance", dataFieldName: "Advance",alignType:'right',width:'8%' },
        { columnName: "Vehicle Type", dataFieldName: "VehicleTypeName",width:'5%' },
        { columnName: "Quote Status", dataFieldName: "QuotationStatus" ,width:'5%'},   //added by fahim 12-01-2026 :)
        { columnName: "Remark", dataFieldName: "Remark" ,width:'12%'},
        { columnName: "Actions", dataFieldName: "actions", divType: "RecordIncomeAction" ,width:'5%'},
      ],
      footerData: [
        { ChargeCode: 'Total', Unit: '', ChargedGST: '', Quantity: '', Rate: '', Discount: '', Amount: '0', Advance: '',QuotationStatus:'',Remark: '' },
        { ChargeCode: 'CGST', Unit: '', ChargedGST: '', Quantity: '', Rate: '', Discount: '', Amount: '0', Advance: '',QuotationStatus:'', Remark: '' },
        { ChargeCode: 'SGST', Unit: '', ChargedGST: '', Quantity: '', Rate: '', Discount: '', Amount: '0', Advance: '',QuotationStatus:'', Remark: '' },
        { ChargeCode: 'IGST', Unit: '', ChargedGST: '', Quantity: '', Rate: '', Discount: '', Amount: '0', Advance: '',QuotationStatus:'', Remark: '' },
        { ChargeCode: 'Round Off', Unit: '', ChargedGST: '', Quantity: '', Rate: '', Discount: '', Amount: '0', Advance: '',QuotationStatus:'', Remark: '' },
        { ChargeCode: 'NetTotal', Unit: '', ChargedGST: '', Quantity: '', Rate: '', Discount: '', Amount: '0', Advance: '',QuotationStatus:'', Remark: '' },

      ],
      actionList: [
        {
          label: 'Edit', command: (event?: any) => console.log(event)
        },
        { label: 'Delete', }],
      isColumnNameShow: true,
      isShowFooterData: true,
    };
  }

  OnChangeAddInvoice() {
    this.dataToSave.Amount =
      this.dataToSave.Quantity * parseFloat(this.dataToSave.Rate || 1);
    this.dataToSave.Amount =
      this.dataToSave.Amount - parseFloat(this.dataToSave.Discount || 0);
  }

  onActionClick({ row, actionName }) {
    if (actionName.trim() == 'Edit') {
      this.isEditMode = true;
      this.dataToSave = {};
      this.dataToSave = row;
      this.dataToSave.Id = row.ID != null ? row.ID : row.Id;

      this.ChargedId.dropdownList=[];
      var obj:any ={};
      obj.value = this.dataToSave.ChargedId != null ? this.dataToSave.ChargedId : this.dataToSave.ChargeId;
      obj.name =this.dataToSave.ChargeCode;
      this.ChargedId.dropdownList.push(obj);

      //added by fahim 12-01-2026 :)
      this.Unit.dropdownList=[];
      var obj1:any ={};
      obj1.value = this.dataToSave.Unit;
      obj1.name =this.dataToSave.Unit;
      this.Unit.dropdownList.push(obj1);
      //End added by fahim 12-01-2026 :)

      this.GetVehicleTypeList(row.VehicleTypeName);
      // this.GetChargesList(row.ChargeCode);
      // let indexToRemove = this.tableDetails.data.findIndex(record => record.SN === row.SN);
      let indexToRemove = this.tableDetails.data.findIndex(record => 
        (row.SN != null && record.SN === row.SN) ||
        (row.SN == null && record.Id === row.Id)
      );
      
      if (indexToRemove !== -1) {
        this.tableDetails.data.splice(indexToRemove, 1);
        this.CalcFooterValue();
      }
    } else if (actionName.trim() == 'Delete') {
      if (row.Id == null) {
        let indexToRemove = this.tableDetails.data.findIndex(record => record.SN === row.SN);
        this.RemoveIncome(indexToRemove);
      } else {
        this.DeleteIncome(row.Id);
      }
    }
  }

  RemoveIncome(index) {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, {
        centered: true,
      });
      dialogRef.componentInstance.details = {
        message: "Are you sure you want to remove this record?",
        title: "Confirmation",
      };
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          RecordIncomeComponent.that.tableDetails.data.splice(
            index,
            1
          );
          RecordIncomeComponent.that.CalcFooterValue();
        }
        dialogRef.close();
      });
    });
  }

  DeleteIncome(Id) {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, {
        centered: true,
      });
      dialogRef.componentInstance.details = {
        message: "Are you sure you want to delete this record?",
        title: "Confirmation",
      };
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          RecordIncomeComponent.that._appService
            .Delete("byVehicleIncome", "DeleteIndentCharge", Id)
            .subscribe(
              (response) => {
                this.toastr.success('Data deleted successfully', 'Ok');
                RecordIncomeComponent.that.CalcFooterValue();
                RecordIncomeComponent.that.GetChargeList();
              },
              (err) => {
                RecordIncomeComponent.that.toastr.error(
                  err._body.replace(/"/g, ""),
                  "error"
                );
              }
            );
        }
        dialogRef.close();
      });
    });
  }

  CalcFooterValue() {
    var sumofTotal = 0;
    let SGST: any = 0.0;
    let CGST: any = 0.0;
    let IGST: any = 0.0;

    var TotalQty = 0;
    var TotalAmount = 0;
    var NetTotalAmount = 0;
    var RoundOfAmount = 0;
    var TotalCGST = 0;
    var TotalSGST = 0;
    var TotalIGST = 0;
    var TotalDiscount = 0;
    var TotalAdvance = 0;

    this.tableDetails.data.forEach((element) => {
      sumofTotal += parseFloat(element.Amount);
      SGST = 0.0;
      CGST = 0.0;
      IGST = 0.0;
      if (
        element.Discount == null ||
        element.Discount == undefined ||
        element.Discount == ""
      ) {
        element.Discount = 0;
      }
      element.Amount = element.Quantity * element.Rate;
      element.Amount = element.Amount - element.Discount;

      if (element.ChargedGST != 'NA') {
        if (element.CGST != null && element.CGST != 0) {
          CGST = element.Amount * (element.CGST / 100);
        }
        if (element.SGST != null && element.SGST != 0) {
          SGST = element.Amount * (element.SGST / 100);
        }
        if (element.IGST != null && element.IGST != 0) {
          IGST = element.Amount * (element.IGST / 100);
        }
        // if (taxvalue == 0 && element.ChargedGST != 'NA') {
        //     TotalIGST = 0,
        //     TotalIGST = 0,
        //     TotalSGST = 0
        // }
      }
      else {
        element.ChargedGST = "NA";
        element.ChargedGSTId = null;
      }

      TotalAmount += element.Amount;
      TotalDiscount += parseFloat(element.Discount);
      TotalQty += parseFloat(element.Quantity);
      TotalAdvance += parseFloat(element.Advance);

      element.CGSTAmount = CGST;
      element.SGSTAmount = SGST;
      element.IGSTAmount = IGST;
      TotalCGST += CGST;
      TotalSGST += SGST;
      TotalIGST += IGST;
    });

    TotalAdvance = parseFloat(TotalAdvance.toFixed(2));
    NetTotalAmount = TotalAmount + TotalCGST + TotalSGST + TotalIGST;
    RoundOfAmount = parseFloat((Math.round(NetTotalAmount) - NetTotalAmount).toFixed(2));
    NetTotalAmount = Math.round(NetTotalAmount);

    setTimeout(() => {
      this.tableDetails.footerData[0].Amount = parseFloat(sumofTotal.toString()).toFixed(2);
      this.tableDetails.footerData[0].Quantity = parseFloat(TotalQty.toString()).toFixed(2);
      this.tableDetails.footerData[0].Discount = parseFloat(TotalDiscount.toString()).toFixed(2);
      this.tableDetails.footerData[0].Advance = parseFloat(TotalAdvance.toString()).toFixed(2);
      this.tableDetails.footerData[1].Amount = parseFloat(TotalCGST.toString()).toFixed(2);
      this.tableDetails.footerData[2].Amount = parseFloat(TotalSGST.toString()).toFixed(2);
      this.tableDetails.footerData[3].Amount = parseFloat(TotalIGST.toString()).toFixed(2);
      this.tableDetails.footerData[4].Amount = parseFloat(RoundOfAmount.toString()).toFixed(2);
      this.tableDetails.footerData[5].Amount = parseFloat(NetTotalAmount.toString()).toFixed(2);

    }, 500);
  }

  SaveTripExpense() {
    Helpers.setLoading(true);
    this.tableDetails.data.forEach(element => {
      element.IndentId = '';
      element.IndentId = this.IndentId;
      element.NetAmount = parseFloat(this.tableDetails.footerData[5].Amount);
      // element.ConsignmentNo = '';
      // element.ConsignmentNo = this.ConsignmentNo;
    });

    setTimeout(() => {
      this._appService.Post("byVehicleIncome", "SaveChargeListForOrdersByVehicle", this.tableDetails.data).subscribe((res) => {
        this.toastr.success("Charge List saved Successfully", "Success")
        this.refreshCostSheet.emit('true');
        this.closeModal();
        this.tableDetails.data = [];
        Helpers.setLoading(false);
      }, (err) => {
        console.log("Error", err);
        Helpers.setLoading(false);
      });
    }, 500);
  }

  GetChargeList() {
      this._appService.GetByTwoId("byVehicleIncome", "GetNewRecordIncomeList", this.IndentId, this.ConsignmentNoteDetailId).subscribe((res) => {
        this.tableDetails.data = [];
        res.forEach(element => {
          element.ChargedId = element.ChargeId;
          element.Id = element.ID;
          this.tableDetails.data.push(element);
        });

        const hasConsignmentNo = this.tableDetails.data.some(item => item.ConsignmentNo !== undefined);
        if (hasConsignmentNo) {
        const alreadyExists = this.tableDetails.columnDetails.some(
          col => col.dataFieldName === "ConsignmentNo"
        );

        if (!alreadyExists) {
          this.tableDetails.columnDetails.splice(0, 0, {
            columnName: "Consignment/Order No",
            dataFieldName: "ConsignmentNo",
            width:'10%' 
          });

          // Also update footerData if necessary (optional)
          this.tableDetails.footerData.forEach(row => {
            row["ConsignmentNo"] = "";
          });
        }
      }
        this.CalcFooterValue();
      }, (err) => {
        console.log("Error", err);
      });
  }

  // GetChargeList() {
  //   if (this.IsConsignmentWise == true) {
  //     if (!this.ConsignmentNoteDetailId)
  //       return

  //     this._appService.GetByTwoId("byVehicleIncome", "GetChargeListByIndentIdConWise", this.IndentId, this.ConsignmentNoteDetailId).subscribe((res) => {
  //       this.tableDetails.data = [];
  //       res.forEach(element => {
  //         element.ChargedId = element.ChargeId;
  //         element.Id = element.ID;
  //         this.tableDetails.data.push(element);
  //       });
  //       this.CalcFooterValue();
  //     }, (err) => {
  //       console.log("Error", err);
  //     });
  //   } else {
  //     this._appService.GetById("byVehicleIncome", "GetChargeListByIndentId", this.IndentId).subscribe((res) => {
  //       this.tableDetails.data = [];
  //       res.forEach(element => {
  //         element.ChargedId = element.ChargeId;
  //         element.Id = element.ID;
  //         this.tableDetails.data.push(element);
  //       });
  //       this.CalcFooterValue();
  //     }, (err) => {
  //       console.log("Error", err);
  //     });
  //   }
  // }

     GetConsignmentList(value, isScrollDown = false,checkSingleResult = false) {
    this.ConsignmentDetailIds.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.ConsignmentDetailIds.dropdownList.length / 20) + 1;
    }
    let Type = '';
    if(this.isOrderLevel === true){
      Type = 'OrderWise'
    }else{
      Type = 'ConsignmentWise'
    }
    this.orderService.ConsignmentWiseList(value,Type,this.OrderNo, this.BookingId).then(res => {
      let dropdownList = [...res];

       if (checkSingleResult && Array.isArray(dropdownList) && dropdownList.length === 1) {
      const item = dropdownList[0];
      this.dataToSave.ConsignmentDetailId = item.value;
      this.dataToSave.ConsignmentNo = item.name;
      this.dataToSave.BookingId = item.BookingId;
    }

      if (isScrollDown && res.Total > this.ConsignmentDetailIds.dropdownList.length) {
        dropdownList = dropdownList.concat(this.ConsignmentDetailIds.dropdownList);
        this.ConsignmentDetailIds = { ...this.ConsignmentDetailIds, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.ConsignmentDetailIds = { ...this.ConsignmentDetailIds, dropdownList: [...dropdownList] });
      this.ConsignmentDetailIds.isSearch = false;
    }).catch(error => {
      this.ConsignmentDetailIds.isSearch = false;
    })
  }

  //added by fahim (12-01-2026)
  GetNewUnitsList(value, isScrollDown = false) {
    this.Unit.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Unit.dropdownList.length / 20) + 1;
    }
    this.orderService.GetNewUnitsList(value).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Unit.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Unit.dropdownList);
        this.Unit = { ...this.Unit, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Unit = { ...this.Unit, dropdownList: [...dropdownList] });
      this.Unit.isSearch = false;
    }).catch(error => {
      this.Unit.isSearch = false;
    })
  }

  CalculateChargesByUnit(ChargesPer){
    let obj:any={};
    obj.OrderId=this.IndentId;
    obj.NetworkId=null;
    obj.ChargesPer=ChargesPer;
    obj.UnitRate=0;
    this._appService.Post('OrdersByVehicle','CalculateChargesByUnit',obj).subscribe(
      (response)=>{
        if(response && response.length>0){
          console.log(response[0].Qty);
          const newQTY = response[0].Qty
          this.dataToSave.Quantity=newQTY;
          // this.dataToSave.Amount = this.dataToSave.Rate * this.dataToSave.Quantity 
          this.dataToSave.Amount = (this.dataToSave.Rate != null ? this.dataToSave.Rate : 0) * (this.dataToSave.Quantity != null ? this.dataToSave.Quantity : 0);
          console.log('this.dataToSave.Quantity',this.dataToSave.Quantity);
        }
      },
      (error)=>{
        this.toastr.error('Error while calculating qty','Error');
      }
    );
  }
  //End added by fahim 12-01-2026 :)

}
